import styles from './MultiTypeaheadItem.module.scss';

import { mergeClassNames } from '../../../utils/mergeClassNames';
import { Checkbox } from '../Checkbox';
import { ReactNode } from 'react';
import { ListBoxItem, ListBoxItemProps } from 'react-aria-components';
import { BetaMultiTypeaheadProps } from './MultiTypeahead';

export type MultiTypeaheadItemProps = ListBoxItemProps & {
  /** ListBoxItem itself can accept render props */
  children: ReactNode;

  /**
   * The size of the item.
   */
  // Doesn't matter, we're just using the size...
  //
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  size: BetaMultiTypeaheadProps<any>['size'];

  // If the item is checked or not
  isChecked: boolean;
};

/**
 * An individual item to be rendered inside a `BetaMultiTypeahead` popover.
 *
 * @private
 */
export const MultiTypeaheadItem = ({
  children,
  className,
  id,
  size,
  textValue,
  isChecked,
  ...props
}: MultiTypeaheadItemProps) => {
  return (
    <ListBoxItem
      className={(renderProps) =>
        mergeClassNames([styles.root, className], renderProps)
      }
      data-size={size}
      data-zds
      id={id}
      textValue={textValue}
      {...props}
    >
      <div className={styles.checkWrapper}>
        <Checkbox isSelected={isChecked} />
      </div>
      {children}
    </ListBoxItem>
  );
};
